import React, { useState, useEffect } from "react"
import { onAuthStateChanged } from "firebase/auth"
import { auth, signInWithGoogle } from "./firebase/config"
import Header from "./components/Header"
import QuestionList from "./components/QuestionList"
import QuestionForm from "./components/QuestionForm"
import "./styles/App.scss"
import { Toaster } from "react-hot-toast"

function App() {
  const [admin, setAdmin] = useState(null)

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      if (user && user.email === "octaltechnologies8@gmail.com") {
        setAdmin(user)
        const currentUserId = auth.currentUser?.uid
        localStorage.setItem("currentUserId", currentUserId)
      } else {
        setAdmin(null)
        localStorage.removeItem("currentUserId")
      }
    })
    return () => unsub()
  }, [])

  return (
    <div className="app-container">
      <Toaster position="top-center" reverseOrder={false} />
      <Header admin={admin} signInWithGoogle={signInWithGoogle} />
      <QuestionList admin={admin} />
      <QuestionForm admin={admin} />
    </div>
  )
}

export default App
